
export const SET_ALERT = "SET_ALERT"